import { AssetMode } from '@shared/api/asset/asset-mode';

/**
 * The asset an edit form currently has staged: one media id plus, per colour mode, the file to
 * upload for it. A mode without a file keeps whatever the server already holds for that media id.
 **/
export interface StagedAsset {
  readonly mediaId: string;
  readonly lightFile: File | undefined;
  readonly darkFile: File | undefined;
}

/** Nothing staged — no media id and no files. **/
export const EmptyStagedAsset: StagedAsset = {
  mediaId: '',
  lightFile: undefined,
  darkFile: undefined,
};

/** The file staged for one colour mode. **/
export function stagedFile(
  asset: StagedAsset,
  mode: AssetMode
): File | undefined {
  return mode === 'light' ? asset.lightFile : asset.darkFile;
}

/** The colour modes a file has been staged for. **/
export function stagedModes(asset: StagedAsset): AssetMode[] {
  const modes: AssetMode[] = [];

  if (asset.lightFile) modes.push('light');
  if (asset.darkFile) modes.push('dark');

  return modes;
}
